module.exports = __webpack_public_path__ + "static/media/041-paraguay.03447d05.svg";